module.exports = __webpack_public_path__ + "img/plus-secondary-circle.a0fc6685.svg";